import { createSlice } from "@reduxjs/toolkit";
import {
  getUserWithFilter,
  updateUserStatus,
  deleteUser,
  bulkDeleteUser,
} from "./thunk";

const initialState = {
  users: [],
  singleUser: null,
  loading: false,
  error: null,
  filterParams: {
    currentPage: 1,
    perPage: 20,
  },
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setFilterParams: (state, action) => {
      state.filterParams = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserWithFilter.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload;
        state.error = null;
      })
      .addCase(getUserWithFilter.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.msg;
      })
      .addCase(updateUserStatus.fulfilled, (state, action) => {
        if (Array.isArray(state.users)) {
          const index = state.users.findIndex(invoice => invoice.id === action.payload.id);
          if (index !== -1) {
            state.users[index] = action.payload;
          }
        } else {

          state.users = [];
        }
        state.users = null;
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        if (Array.isArray(state.users)) {
          state.users = state.users.filter(
            (user) => user.userId !== action.payload
          );
        } else {
          state.users = [];
        }
        state.error = null;
      })
      .addCase(bulkDeleteUser.fulfilled, (state, action) => {
        if (Array.isArray(state.users)) {
          state.users = state.users.filter(
            (user) => !action.payload.includes(user.userId)
          );
        } else {
          state.users = [];
        }
        state.error = null;
      })
  },
});

export const { setFilterParams } = userSlice.actions;
export default userSlice.reducer;
